<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <h5>{{ $t('views.technicians.index.header') }} ({{ techniciansNumber }}) <b-button v-b-tooltip.hover :title="$t('buttons.search')"  v-b-toggle.technicians-filtering variant="primary"><i class="fa fa-filter"></i></b-button></h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-collapse id="technicians-filtering">
            <Filtering></Filtering>
          </b-collapse>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col>
                <div
                        v-if="isLoading"
                        class="alert alert-info">Loading...</div>
                <div
                        v-if="error"
                        class="alert alert-danger">{{ error }}</div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-row v-for="(item, index) in items" v-bind:key="'technician-' + index" class="border-bottom">
                  <b-col>
                    <TechnicianRow :item="item"></TechnicianRow>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import Filtering from './components/index/Filtering'
import TechnicianRow from './components/index/TechnicianRow'
export default {
  name: 'Index',
  components: {
    Filtering,
    TechnicianRow
  },
  data () {
    return {
      url: 'api/user_datas?idClientType=5&_page=1',
      techniciansNumber: 0,
      isLoading: true,
      items: []
    }
  },
  created () {
    this.channelTechinicians = this.$store.state.Pusher.subscribe('user_datas')
    this.channelTechinicians.bind('user_datas', data => {
      this.getTechnicians(this.url)
    })
    this.getTechnicians(this.url)
  },
  methods: {
    // mouseOn (index) {
    //   // console.log('najechałem na: ' + index)
    //   this.items[index].hover = 1
    //   console.log(this.items[index].hover)
    // },
    // mouseOff (index) {
    //   // console.log('zjechałem z: ' + index)
    //   this.items[index].hover = 0
    // },
    getTechnicians (url) {
      this.url = url
      this.isLoading = true
      this.$http
        .get(url)
        .then(response => {
          // this.$store.state.views.dispatcher.notAssignedTasksNumber = response.data['hydra:totalItems']
          this.view = response.data['hydra:view']
          this.items = response.data['hydra:member']
          for (let i in this.items) {
            this.items[i].hover = 0
          }
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          console.log(error)
          this.error = error
        })
    }
  }
}
</script>
